module.exports = __webpack_public_path__ + "static/media/react-logo.254e2aad.png";